const actions = {
  SET_STATE: 'dashboard/SET_STATE',
  GET_ZERO_DASHBOARD: 'dashboard/GET_ZERO_DASHBOARD',
}

export default actions
